<template>

  <v-col cols="12" md="6" lg="4">
    <v-sheet class="rounded-lg">
      <div class="image-wrapper">
        <img :src="image || placeholderImage" alt="Promotion Image" class="image rounded-t-lg">
      </div>
      <v-container>
        <v-row>
          <v-col cols="12" class="py-0">
            <p v-if="tag != ''" class="badge-tag">{{ tag }}</p>
            <p v-else class="badge-tag empty">&nbsp;</p>
          </v-col>
          <v-col cols="12" class="pb-0">
            <p class="date">Finaliza em {{ ends_at }}</p>
          </v-col>
          <v-col cols="12" class="py-0">
            <h3 class="title">{{ title }}</h3>
            <p class="text">{{ text }}</p>
          </v-col>
          <v-col cols="12">
            <p class="states" v-html="place || '&nbsp;'"></p>
            <div class="d-flex">
              <v-btn
                @click="redirectToUrl"
                class="bg-amber-darken-1 ml-auto"
                rounded
                variant="flat"
              >
                Saiba mais
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-col>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useDisplay } from 'vuetify';

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    tag: {
        type: String,
        required: true,
    },
    place: {
        type: String,
        required: true,
    },
    uuid: {
        type: String,
        required: true,
    },
    text: {
        type: String,
        required: true,
    },
    image: {
        type: String,
        required: true,
    },
    ends_at: {
        type: String,
        required: true,
    },
});
const placeholderImage = require('@/assets/whiteLogo.svg');
const { xs } = useDisplay();
const isMobile = xs.value;
const router = useRouter();

const redirectToUrl = () => {
  router.push('/promocoes/' + props.uuid);
}

</script>

<style scoped lang="scss">

.image-wrapper {
  display: flex;
  width:100%;
  /*height: 250px;*/
}
/*
@media (max-width: 1904px) {
  .image-wrapper {
    height: 150px;
  }
}
*/
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 20px;
}

.title {
  font-size: 22px;
  text-align: left;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text {
  color: grey;
  font-size: 14px;
  text-align: left;
  margin-bottom: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.date {
    font-size: 14px;
    text-align: left;
    color: gray;
    margin-bottom: 10px;
}

.badge-tag {
	display: inline-block;
  float:left;
  background-color: none;
  color: $verde-opus;
  margin: 2px;
  padding: 3px 8px;
  border: 2px solid $verde-opus;
  border-radius: 20px;
  text-align: center;
  font-size: 12px;
}
.badge-tag.empty {
	opacity: 0;
}
.states {
  display: flex;
  align-items: center;
  font-size: 14px;
  text-align: left;
  color: gray;
  margin: 0.7em 0;
}


</style>
